// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"230":"d0d24233dfdf0c8c6165","256":"f5b9d0e11755f41cc8cd","731":"5e23319c1adfe1c9f346","843":"4b3ec0b019585b06c65c"}[chunkId] + ".js";
};